var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input_light-search"},[_c('div',{staticClass:"input_light-search__search-icon"},[_c('MagnifyIcon',{attrs:{"fill-color":"#606060"}})],1),_c('InputLight',{staticClass:"input_light_search",attrs:{"placeholder":_vm.placeholder,"type":_vm.type,"value":_vm.value},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }